import { defineStore } from 'pinia'

import { ref } from 'vue'

import { AuthApi, SocialLoginType } from '@/features/api/services/authApi.js'
import { useAuthRedirection } from '@/features/auth/useAuthRedirection.js'
import { useAuthStore } from '@/features/auth/useAuthStore.js'
import {
  AccountIsNotExist,
  UserIsNotExist,
  useLoginStore,
} from '@/features/auth/views/login/useLoginStore.js'
import { useClubRouter } from '@/features/router/useClubRouer.js'
import { useToaster } from '@/features/ui/toaster/useToaster.js'

export const useSocialLoginStore = defineStore('socialLoginStore', function () {
  const isLoading = ref(false)
  const toaster = useToaster()
  const loginStore = useLoginStore()

  const authStore = useAuthStore()

  const loginEmailEnterUserIsNotExistCallback = ref(null)
  const { redirectUrl } = useAuthRedirection()

  const router = useClubRouter()
  async function handleLoginWithGoogle(token) {
    try {
      isLoading.value = true
      const loginResponse = await AuthApi.socialLogin({
        socialToken: token,
        socialLoginType: SocialLoginType.Google,
      })

      await authStore.setUserToken(loginResponse.auth_token)

      await loginStore.decideNavigation()
    } catch (e) {
      console.error(e)
      const errorData = e?.response?.data

      toaster.error({ title: errorData })

      if (errorData === UserIsNotExist || errorData === AccountIsNotExist) {
        if (loginEmailEnterUserIsNotExistCallback.value) {
          loginEmailEnterUserIsNotExistCallback.value({ errorData })
          return
        }

        console.log('User is not exist, redirect to register')

        await router.push('/auth/register?redirectUrl=' + redirectUrl)
      }
    } finally {
      isLoading.value = false
    }
  }

  function setLoginEmailEnterUserIsNotExistCallback(callback) {
    loginEmailEnterUserIsNotExistCallback.value = callback
  }

  return {
    handleLoginWithGoogle,
    setLoginEmailEnterUserIsNotExistCallback,

    isLoading,
  }
})
